import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const StyledCard = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    border-radius: 8px;
    padding: 33px;
    background-color: ${colors.light};
    flex: 1;

    .content-header {
      display: flex;
      align-items: center;
      
      img.icon {
        max-width: 40px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        margin-bottom: 25px;
      }
    }

    .text-title {
        margin-bottom: 29px;
    }

    h4 {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 32px;
        letter-spacing: 0;
        color: ${colors.lightRed};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
        margin-top: 10px;
        line-height: 21px;
      }
    
    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: ${colors.grey};
        font-size: 23px;
        text-align: left;
        margin-top: 5px;
        line-height: 36px;
    }

    @media screen and (max-width: 1919px) { 
    padding: 33px;

    h4 {
        font-size: 20px;
        letter-spacing: 0;
      }
    
    .content-body {
        font-size: 14px;
        margin-top: 0;
        line-height: 20px;
    }
    }
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        padding: 33px 0 33px 18px;
        .content-body {
        font-size: 12px;
        margin-top: 0;
        line-height: 20px;
    }
    }
`;
